// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rXVA","col":"styles_col__3pqkW"};